import React from "react";
import "../../css/lp-sect-one.css";
import Course from "../../components/Course.js";
import CourseImg1 from "../../assets/images/sect1-course1-pic.png";
import CourseImg2 from "../../assets/images/sect1-course2-pic.png";
import { ReactComponent as BlueDot } from "../../assets/icons/main-sect1/dot-blue.svg";
import { ReactComponent as GreenDot } from "../../assets/icons/main-sect1/dot-green.svg";
import { ReactComponent as RedDot } from "../../assets/icons/main-sect1/dot-red.svg";

// a reminder to future emmo to break this down into further subject component
const Sect1 = () => {
  return (
    <section id="lp-sect-1">
      <div>
        <RedDot id="red" className="abs" />
        <GreenDot id="green" className="abs" />
        <BlueDot id="blue" className="abs" />
        <article>
          <h2>Top subject/courses</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>
        </article>
        <div>
          <div className="subject-head">
            <h3>General subject/courses</h3>
            <div>
              <div>
                <button className="active">Mathematics</button>
                <button>English</button>
                <button>Biology</button>
                <button>Geography</button>
              </div>
              <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                See more
              </a>
            </div>
          </div>
          <div className="course-list-cont">
            <div className="course-list">
              <Course id={"active-course"} courseImage={CourseImg1} />
              <Course courseImage={CourseImg2} />
              <Course courseImage={CourseImg1} />
              <Course courseImage={CourseImg2} />
            </div>
          </div>
        </div>
        <div>
          <div className="subject-head">
            <h3>Arts subject/courses</h3>
            <div>
              <div>
                <button className="active">Mathematics</button>
                <button>English</button>
                <button>Biology</button>
                <button>Geography</button>
              </div>
              <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                See more
              </a>
            </div>
          </div>
          <div className="course-list-cont">
            <div className="course-list">
              <Course courseImage={CourseImg1} />
              <Course courseImage={CourseImg2} />
              <Course courseImage={CourseImg1} />
              <Course courseImage={CourseImg2} />
            </div>
          </div>
        </div>
        <div>
          <div className="subject-head">
            <h3>Commercial subject/courses</h3>
            <div>
              <div>
                <button className="active">Mathematics</button>
                <button>English</button>
                <button>Biology</button>
                <button>Geography</button>
              </div>
              <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                See more
              </a>
            </div>
          </div>
          <div className="course-list-cont">
            <div className="course-list">
              <Course courseImage={CourseImg1} />
              <Course courseImage={CourseImg2} />
              <Course courseImage={CourseImg1} />
              <Course courseImage={CourseImg2} />
            </div>
          </div>
        </div>
        <div>
          <div className="subject-head">
            <h3>Science subject/courses</h3>
            <div>
              <div>
                <button className="active">Mathematics</button>
                <button>English</button>
                <button>Biology</button>
                <button>Geography</button>
              </div>
              <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                See more
              </a>
            </div>
          </div>
          <div className="course-list-cont">
            <div className="course-list">
              <Course courseImage={CourseImg1} />
              <Course courseImage={CourseImg2} />
              <Course courseImage={CourseImg1} />
              <Course courseImage={CourseImg2} />
            </div>
          </div>
        </div>
        <div>
          <div className="subject-head">
            <h3>Technical subject/courses</h3>
            <div>
              <div>
                <button className="active">Mathematics</button>
                <button>English</button>
                <button>Biology</button>
                <button>Geography</button>
              </div>
              <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                See more
              </a>
            </div>
          </div>
          <div className="course-list-cont">
            <div className="course-list last">
              <Course courseImage={CourseImg1} />
              <Course courseImage={CourseImg2} />
              <Course courseImage={CourseImg1} />
              <Course courseImage={CourseImg2} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sect1;
